// Set up namespace
window.paylocity = window.paylocity || {};
window.paylocity.talent = window.paylocity.talent || {};
window.paylocity.talent.forms = window.paylocity.talent.forms || {};
